import { render, staticRenderFns } from "./firstLetter.vue?vue&type=template&id=2c98afa7&scoped=true"
import script from "./firstLetter.vue?vue&type=script&lang=js"
export * from "./firstLetter.vue?vue&type=script&lang=js"
import style0 from "./firstLetter.vue?vue&type=style&index=0&id=2c98afa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c98afa7",
  null
  
)

export default component.exports